import {
  CashAndBankRepository,
  CashBankAccountsResultEntity,
  CashBankSplitTransactionParams,
  CashBankSummaryEntity,
  CashBankSummaryParams,
  CashBankTransactionListParams,
  CashBankTransactionsResultEntity,
} from "../../domain";
import {
  fetchCashBankAccounts,
  fetchCashBankSummary,
  fetchCashBankTransactions,
  splitCashBankTransaction,
} from "../api/cashAndBankApi";
import { CashAndBankMapper } from "../mappers/CashAndBankMapper";

export class CashAndBankRepositoryImpl implements CashAndBankRepository {
  async fetchAccounts(): Promise<CashBankAccountsResultEntity> {
    const response = await fetchCashBankAccounts();
    return CashAndBankMapper.toAccountsResultEntity(response);
  }

  async fetchTransactions(
    params: CashBankTransactionListParams,
  ): Promise<CashBankTransactionsResultEntity> {
    const response = await fetchCashBankTransactions({
      account_id: params.accountId,
      debit_or_credit: params.type,
      status: params.status,
      limit: params.limit,
      offset: params.offset,
      sort_by: params.sortBy,
      sort_order: params.sortOrder,
      search: params.search,
      date_from: params.dateFrom,
      date_to: params.dateTo,
    });

    return CashAndBankMapper.toTransactionsResultEntity(response);
  }

  async fetchSummary(
    params: CashBankSummaryParams = {},
  ): Promise<CashBankSummaryEntity> {
    const response = await fetchCashBankSummary({
      account_id: params.accountId,
      date_from: params.dateFrom,
      date_to: params.dateTo,
    });

    return CashAndBankMapper.toSummaryEntity(response);
  }

  async splitTransaction(params: CashBankSplitTransactionParams): Promise<void> {
    await splitCashBankTransaction({
      transaction_id: params.transactionId,
      splits: params.splits,
    });
  }
}
